import { render } from "./VTableBody.vue?vue&type=template&id=f595f29a&ts=true"
import script from "./VTableBody.vue?vue&type=script&lang=ts"
export * from "./VTableBody.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__